<div class="modal-dialog-scrollable m-0 scrollable-dialog dialog-preview-modal">
    <div class="container-fluid text-center">
        <iframe *ngIf="data.type == 'youtube'" [src]="youtubeLink(data.dialog.desktop_link) | safe:'resourceUrl'" width="100%" height="300" class="fixed-padding"></iframe>
        <img class="fixed-padding" *ngIf="data.type == 'image'" [src]="data.dialog.desktop_link" />
        <h3 [innerHTML]="data.dialog.title" class="dialog-preview-title m-auto"></h3>
        <div [innerHTML]="alignedContent(data.dialog.content)" class="dialog-preview-content"></div>
        <button *ngIf="data.dialog.cta_button_text" class="btn btn-success w-50">{{data.dialog.cta_button_text | uppercase }}</button>
    </div>
</div>